
import { Vue, Component } from 'vue-property-decorator';
import { ChartData } from 'chart.js';
import { getMarkerStyle, getPrice } from '@/features/common/helpers';
import { CostBreakdownCarrier, CostBreakdownData } from '@/features/dashboard/types';

@Component
export default class CouriersStatistics extends Vue {
  private hexColors: Array<string> = [
    '#ffa43c', '#2bc5cb', '#623ec7', '#22c55e',
    '#ec4899', '#0ea5e9', '#f43f5e', '#eab308', '#10b981', '#d946ef',
    '#65a30d', '#b2b2c2',
  ];

  private chartKey = 'chartKey';

  get doughnutChartData(): ChartData {
    this.chartKey = `${this.chartKey}--${Date.now()}`;

    return {
      datasets: [
        {
          label: 'Q32021',
          backgroundColor: this.hexColors.slice(0, this.carriers.length - 1),
          data: this.packageCount,
          borderWidth: 0,
        },
      ],
    };
  }

  get packageCount(): Array<number> {
    return this.widgetData.breakdownPerCarrier.map((carrier) => carrier.packageCount);
  }

  get widgetData(): CostBreakdownData {
    return this.$store.getters.getWidgets.costBreakdown.data;
  }

  get carriers(): Array<CostBreakdownCarrier> {
    return this.widgetData.breakdownPerCarrier;
  }

  private getMarkerStyle = getMarkerStyle;

  private getPrice = getPrice;
}
